/* 

just calculate the distance between two users

from https://www.movable-type.co.uk/scripts/latlong.html

*/

export function calcDistance(me, them, miles) {
  
  const R = 6371000; // metres
  const φ1 = me.lat * Math.PI / 180; // φ, λ in radians
  const φ2 = them.lat * Math.PI / 180;
  const Δφ = (them.lat - me.lat) * Math.PI / 180;
  const Δλ = (them.long - me.long) * Math.PI / 180;
  
  const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2( Math.sqrt(a), Math.sqrt(1 - a) );

  let d = R * c; // in meters
  
  if (miles == true) {
    // return in rounded miles
    d = Math.round(d * 0.0621371);
    d /= 100;
  } else {
    // return in rounded kilometers
    d = Math.round(d / 10);
    d /= 100;
  }
  
  return d;
}


// rejiggered from https://gis.stackexchange.com/a/301330
// radius should be in kilometers
export function getBoundsFromLatLong(lat, long, radius){
  
  
  // degrees to radians
  let radians = lat * ( Math.PI / 180 )
  // console.log("radians:", radians);
  
  let latChange = radius / 111.11;
  let longChange = latChange / Math.cos( radians );
  
  // console.log("latChange:", latChange);
  // console.log("lonChange:", longChange);
  
  let bounds = { 
    latMin : Math.round( (lat - latChange) * 1000 ) / 1000,
    longMin : Math.round( (long - longChange) * 1000 ) / 1000,
    latMax : Math.round( (lat + latChange) * 1000 ) / 1000,
    longMax : Math.round( (long + longChange) * 1000 ) / 1000
  };
  
  // console.log("bounds:", bounds);
  
  // full precision
  // let bounds2 = { 
  //     latMin : lat + latChange,
  //     longMin : long - lonChange,
  //     latMax : lat - latChange,
  //     longMax : long + lonChange
  // };
  
  // console.log("bounds2:", bounds2);
  
  return bounds;
}


// helps slightly randomize gps locations
export function randoGPS(lat, long) {
  // we need to randomize the location a little bit so we don't have an
  // exact location for privacy reasons
  // 33.872333, -117.932508
  // 33.872297, -117.933699
  
  // something like above should turn into something like below:
  // 33.872, -117.935
  
  // lop off anything after the third decimal place and then add a 
  // little bit of randomness
  let tlat = Math.round( ( lat + ( ( Math.random() - 0.5) / 100 ) ) * 1000) / 1000;
  let tlong = Math.round( ( long + ( ( Math.random() - 0.5) / 100 ) ) * 1000) / 1000;
  
  // console.log("randomized lat,long to save:", tlat + ", " + tlong);
  
  return {tlat: tlat, tlong: tlong};
}